import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { bettingOddsSelector } from '../../../../store/js/modules/competition-nav/selectors';

import { useGetBettingOddsQuery } from '../../../../store/js/modules/api/cfs-api';
import { useIsBettingSuppressed } from '../../../../../../common/react/utils/is-betting-suppressed';

const POLLING_INTERVAL = 30000;

export const FixtureBettingOdds = ({ match }) => {
    const bettingOdds = useSelector(bettingOddsSelector);

    const { data, isError } = useGetBettingOddsQuery('', {
        pollingInterval: POLLING_INTERVAL
    });

    const isBettingMatch = data?.competition?.books?.find(
        (item) => item.matchId === match.providerId
    );

    const renderOddsItem = (team) => {
        if (!team) {
            return;
        }

        const proposition = isBettingMatch.propositions.find(
            (item) => item.clubId === team.providerId
        );

        return (
            <a
                href={proposition?.contextualUrls?.fixture}
                className="fixtures__betting-odds-value"
            >
                ${proposition.h2h.toFixed(2)}
            </a>
        );
    };

    const { isBettingSuppressed } = useIsBettingSuppressed(data);

    // render empty state

    if (!bettingOdds.isActive || !data?.competition?.books || isError) {
        return <></>;
    }

    if (!isBettingMatch) {
        return <></>;
    }

    return (
        <>
            {!isBettingSuppressed && (
                <>
                    <div className="fixtures__betting-odds-value-wrapper">
                        {renderOddsItem(match.home?.team)}
                    </div>
                    <img
                        className="fixtures__sportsbet-logo"
                        src={`/resources/${window.RESOURCES_VERSION}/i/elements/sports-bet-on-white.png`}
                    />
                    <div className="fixtures__betting-odds-value-wrapper">
                        {renderOddsItem(match.away?.team)}
                    </div>
                </>
            )}
        </>
    );
};

FixtureBettingOdds.propTypes = {
    match: PropTypes.object.isRequired
};
